var $e0f84ece0b26ddd5$exports = {};
$e0f84ece0b26ddd5$exports = {
    "pending": `\u{BCF4}\u{B958} \u{C911}`
};


export {$e0f84ece0b26ddd5$exports as default};
//# sourceMappingURL=ko-KR.mjs.map
